// src/components/FloatingCallButton.js
import React, { useState, useEffect } from 'react';
import './FloatingCallButton.css';

// Import FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

function FloatingCallButton() {
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(false);
  
  // Show the button after scrolling a bit
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
        setExpanded(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  // Toggle expanded state
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };
  
  if (!visible) return null;
  
  return (
    <div className={`floating-call-container ${expanded ? 'expanded' : ''}`}>
      {expanded && (
        <div className="floating-actions">
          <a href="/contact" className="floating-action contact-action">
            <FontAwesomeIcon icon={faEnvelope} />
            <span className="action-label">Message</span>
          </a>
          <a href="tel:07735005695" className="floating-action call-action">
            <FontAwesomeIcon icon={faPhone} />
            <span className="action-label">Call Now</span>
          </a>
        </div>
      )}
      
      <button 
        className="floating-call-button" 
        onClick={toggleExpanded}
        aria-label={expanded ? "Close contact options" : "Open contact options"}
      >
        <FontAwesomeIcon icon={expanded ? faTimes : faPhone} className="button-icon" />
      </button>
    </div>
  );
}

export default FloatingCallButton;